import { Fragment, useContext } from "react";
import Grid from "@mui/material/Grid";

import { RenderContext } from "../../Context/RenderContext";

//
const Body = () => {
  //<></>

  const { handlePageconten } = useContext(RenderContext);

  return (
    <Fragment>
      <Grid container>
       
        {handlePageconten()}
      </Grid>
    </Fragment>
  );
};
export default Body;
